import GenericForm from "./GenericForm";

export default function GenericFormPage() {
  return <GenericForm loading={false} />;
}
